import { useRequest } from 'ahooks'

import { http } from '@/utils'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'
const hrmDynamicFielDetail = (data: any): any => http.post('/hrm/dynamic_field/detail', data)
// 删除明细
const deleteDynamicFielDetail = (data: any) => http.delete('/hrm/dynamic_field/detail', { data })
export default ({ value, employeeIds, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  // const staffId = decodeURIComponent(getQuery('staffId') || '')
  // 保存明细
  const { run: runSaveDynamicFielDetail, loading: hrmDynamicFielDetailLoading } = useRequest(
    hrmDynamicFielDetail,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )

  // 删除明细
  const { run: runDeleteDynamicFielDetail, loading: deleteDynamicFielDetailLoading } = useRequest(
    deleteDynamicFielDetail,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    onOpen({ status: 'Edit', editItem: value?.[index] || {} })
  }

  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runSaveDynamicFielDetail,
    runDeleteDynamicFielDetail,
    hrmDynamicFielDetailLoading,
    deleteDynamicFielDetailLoading
  }
}
